import { createDraftSafeSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { WebSocketRequestMessage_Subscription } from '../proto/generated/websocket';

const state = (state: RootState) => state

export const selectWebsocketSubscribeList = createDraftSafeSelector(state, (state: RootState) => state.websocketStore.subscriptionList as WebSocketRequestMessage_Subscription)
